class NotificationService {

  showSuccessNotification(text) {
    this._notificationSystem.addNotification({
      message: `<i class="fa fa-info-circle" aria-hidden="true" style="color: white;"></i>  ${text}`,
      level: 'success',
      autoDismiss: 3,
    });
  }

  showErrorNotification(text) {
    this._notificationSystem.addNotification({
      message: `<i class="fa fa-info-circle" aria-hidden="true" style="color: white;"></i>  ${text}`,
      level: 'error',
      autoDismiss: 3,
    });
  }

  setNotificationSystem(item) {
    this._notificationSystem = item;
  }
}

export default new NotificationService();



/** WEBPACK FOOTER **
 ** ./js/components/notification/notificationService.js
 **/